import LightTheme from 'cl-layout/LightTheme';
import * as React from 'react';
export * from 'original/Menu/Menu';
import * as _ from 'lodash';
import MuiMenu, {MenuProps} from 'original/Menu/Menu';
import {Overwrite} from 'utility-types';
import {findDOMNode} from 'react-dom';
import {ExtendedButtonProps} from '../Button';

// this is an attempt to create a type that includes all elements that can have an onClick prop...
// not sure if it really blocks elements that cant have onClick and if it enables elements that can have onClick but dont pass it... but it works for what I checked
class Menu extends React.PureComponent<
  Overwrite<MenuProps, {open?: boolean}> & {button?: React.ReactElement<{onClick: React.MouseEventHandler<any>}>} & (
      | {
          propagatePropsTo?: 'button';
          size?: ExtendedButtonProps['size'];
        }
      | {
          propagatePropsTo?: 'menu';
        }),
  {anchorEl: HTMLElement; open: boolean}
> {
  static defaultProps = {
    propagatePropsTo: 'menu',
  };

  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      open: false,
    };
  }

  componentDidMount() {
    this.setState({anchorEl: findDOMNode(this) as HTMLElement});
  }

  componentWillReceiveProps(nextProps) {
    const {open} = nextProps;
    if (this.props.open !== open) {
      this.setState({open});
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.button !== prevProps.button) {
      this.componentDidMount();
    }
  }

  openMenu = () => {
    this.setState({open: true});
  };

  closeMenu = () => {
    const {onClose} = this.props;
    if (onClose) {
      onClose(null, null);
    }
    this.setState({open: false});
  };

  render() {
    const {onClick, onClose, button, classes, children, propagatePropsTo, ...otherProps} = this.props;
    const {anchorEl, open} = this.state;
    if (!button) {
      return <MuiMenu open={open} {...this.props} />;
    }
    return (
      <React.Fragment>
        {React.cloneElement(button, {
          ...(propagatePropsTo === 'button' ? otherProps : undefined),
          onClick: event => {
            this.openMenu();
            if (_.isFunction(button.props.onClick)) {
              button.props.onClick(event);
            }
          },
        })}
        <LightTheme>
          <MuiMenu
            anchorEl={anchorEl}
            open={open}
            onClick={event => {
              event.stopPropagation();
              this.closeMenu();
              if (onClick) {
                onClick(event);
              }
            }}
            onClose={event => {
              this.closeMenu();
              if (onClose) {
                onClose(event, null);
              }
            }}
            disableEnforceFocus
            {...(propagatePropsTo === 'menu' ? otherProps : undefined)}
          >
            {children}
          </MuiMenu>
        </LightTheme>
      </React.Fragment>
    );
  }
}

export default Menu;
